import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SenhaService } from "../recuperar-senha/senha.service";
import { Location } from '@angular/common';


@Component({
  selector: 'app-redefinir-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.css']
})
export class RedefinirSenhaComponent implements OnInit {

  codigo!: string;
  form!: FormGroup;
  showNovaSenha: boolean = false;
  showConfirmarSenha: boolean = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private senhaService: SenhaService,
    private toast: ToastrService,
    private router: Router,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.codigo = this.route.snapshot.paramMap.get('codigo') || '';

    this.form = this.fb.group(
      {
        novaSenha: ['', [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[@#$&*!]).+$/)
        ]],
        confirmarSenha: ['', Validators.required]
      },
      {
        validators: [this.senhasIguaisValidator]
      }
    );
  }

  senhasIguaisValidator(group: AbstractControl): ValidationErrors | null {
    const senha = group.get('novaSenha')?.value;
    const confirmar = group.get('confirmarSenha')?.value;
    return senha === confirmar ? null : { senhasDiferentes: true };
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const novaSenha = this.form.value.novaSenha;

    this.senhaService.alterarSenha(this.codigo, novaSenha).subscribe({
      next: () => {
        this.toast.success('Senha alterada com sucesso!')
        this.redirectTo('login');
      },
      error: (err) => {
        const mensagem = Array.isArray(err.error) && err.error[0]?.message
          ? err.error[0].message
          : 'Erro ao alterar a senha.';
        this.toast.error(mensagem);
      }
    });
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate([uri]));
  }

  cancelar(): void {
    this.location.back();
  }

  togglePasswordVisibility(field: 'showNovaSenha' | 'showConfirmarSenha'): void {
    this[field] = !this[field];
  }

}
